import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { notifications } from "@mantine/notifications";
import { CancelOutlined, CheckCircleOutline, InfoOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { playwright_notification_error, playwright_notification_info, playwright_notification_success } from "@therapprove/playwright";
const autoCloseTime = 3000;
export const showSuccessNotification = (message, customCloseTime) => {
    notifications.show({
        message: message,
        color: "var(--mantine-color-green-5)",
        autoClose: customCloseTime ?? autoCloseTime,
        icon: _jsx(SvgIcon, { component: CheckCircleOutline }),
        "data-testid": playwright_notification_success
    });
};
export const showInfoNotification = (message) => {
    notifications.show({
        message: message,
        color: "var(--mantine-color-blue-5)",
        autoClose: autoCloseTime,
        icon: _jsx(SvgIcon, { component: InfoOutlined }),
        "data-testid": playwright_notification_info
    });
};
export const showErrorNotification = (message, customCloseTime) => {
    message = message ? message : "An error occurred. Please try again...";
    notifications.show({
        message: message,
        color: "var(--mantine-color-red-5)",
        autoClose: customCloseTime ?? autoCloseTime,
        icon: _jsx(SvgIcon, { component: CancelOutlined }),
        "data-testid": playwright_notification_error
    });
};
export const showUpdateNotification = (message) => {
    const defaultMessage = "A new version is available. Please refresh to get the latest updates.";
    notifications.show({
        message: (_jsxs("div", { children: [message || defaultMessage, _jsx("br", {}), _jsx("a", { href: "#", onClick: (e) => {
                        e.preventDefault();
                        window.location.reload();
                    }, style: {
                        color: "inherit",
                        textDecoration: "underline",
                        cursor: "pointer",
                        fontWeight: 500
                    }, children: "Click here to refresh" })] })),
        color: "var(--mantine-color-blue-5)",
        autoClose: false, // Don't auto-close since user needs to take action
        icon: _jsx(SvgIcon, { component: InfoOutlined }),
        "data-testid": "update-notification"
    });
};
